var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 12.0001L19.7242 5.60679C20.0922 5.23879 20.0922 4.64399 19.7242 4.276C19.3562 3.908 18.7614 3.908 18.3934 4.276L12.0001 10.6693L5.60679 4.276C5.23879 3.908 4.64399 3.908 4.276 4.276C3.908 4.64399 3.908 5.23879 4.276 5.60679L10.6693 12.0001L4.276 18.3934C3.908 18.7614 3.908 19.3562 4.276 19.7242C4.45952 19.9077 4.70046 19.9999 4.94139 19.9999C5.18233 19.9999 5.42326 19.9077 5.60679 19.7242L12.0001 13.3309L18.3934 19.7242C18.5769 19.9077 18.8179 19.9999 19.0588 19.9999C19.2997 19.9999 19.5407 19.9077 19.7242 19.7242C20.0922 19.3562 20.0922 18.7614 19.7242 18.3934L13.3309 12.0001Z",
    fill: "#323740",
    stroke: "#323740",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose24);
export default __webpack_public_path__ + "static/media/close-24.19b49a4ca108bcad0bbc7544b15ad535.svg";
export { ForwardRef as ReactComponent };